<template>
  <b-form-select
    v-model="valueData"
    class="editable-select"
    :options="options"
    :disabled="disabled"
    @change="endEdit"
    ref="select"
  />
</template>

<script>
export default {
  data: function() {
    return {
      valueData: this.value
    };
  },
  props: {
    units: {
      type: Array,
      default: function() {
        return [];
      }
    },
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    nullable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    options: function() {
      const unitOptions = [];
      if (this.nullable) {
        unitOptions.push({ value: null, text: "-" });
      }
      for (const u of this.units) {
        if (typeof u === "string") {
          unitOptions.push({ value: u, text: u });
        } else {
          unitOptions.push({ value: u.value, text: u.text });
        }
      }
      if (
        this.value &&
        typeof this.value === "string" &&
        this.units.indexOf(this.value) < 0
      ) {
        unitOptions.push({ value: this.value, text: this.value });
      }
      return unitOptions;
    }
  },
  methods: {
    endEdit: function() {
      this.$emit("input", this.valueData);
      this.$refs.select.blur();
    }
  },
  watch: {
    value: function(val) {
      this.valueData = val;
    }
  }
};
</script>
<style scoped lang="scss">
.editable-select {
  width: calc(100% - 8px);
  padding: 0 3px;
  text-align: center;
  text-align-last: center;
  background: none;
  height: auto;
  font-size: 0.875rem;
  color: $body-color;
  border: none;

  &:hover {
    cursor: pointer;
    background-color: $hover-background-color;
  }
}

select:focus,
select:active {
  box-shadow: none;
  border: none;
  outline: none;
}
</style>